import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getAMLSCommonGlobalSettingsPageInfo } from '../../../redux/actions/settings';
import DetailedAlertInvestigation from './DetailedAlertInvestigation';

function mapStateToProps(state) {
  const { amlsCommonSetting = {} } = state.settings;
  const { data = null, error, isLoading } = amlsCommonSetting;
  const { data:alertDetails } = state?.amlsCommon?.alertDetails;
  return {
    settings: data,
    isLoading,
    error,
    alertDetails
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      { getAMLSCommonGlobalSettingsPageInfo },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DetailedAlertInvestigation)
);
